import { useEffect, useRef } from "react";
import { observer } from "mobx-react-lite";
import { useZendeskSupport } from "#resources/hooks/use-zendesk-support";
import { useAnalytics } from "#structure/providers/analytics/analytics-provider";
import { useAmplitudeBaseContext } from "#resources/hooks/use-amplitude-base-context";
import { subscribeZendeskOpen } from "#structure/providers/zendesk";

interface ZendeskLauncherProps {
	pathname: string;
}

export const ZendeskLauncher = observer(function ZendeskLauncher({
	pathname,
}: ZendeskLauncherProps) {
	const { syncLauncher, buildFields } = useZendeskSupport();
	const { sendEvent } = useAnalytics();
	const baseContext = useAmplitudeBaseContext();

	const fieldsKey = JSON.stringify(buildFields());

	useEffect(() => {
		syncLauncher(pathname);
	}, [pathname, fieldsKey]);

	// O listener é registrado uma única vez; o ref mantém sendEvent e o contexto
	// sempre atualizados sem precisar re-inscrever a cada render.
	const trackRef = useRef({ sendEvent, baseContext });
	trackRef.current = { sendEvent, baseContext };

	useEffect(
		() =>
			subscribeZendeskOpen(() => {
				trackRef.current.sendEvent("support_chat_widget", trackRef.current.baseContext);
			}),
		[],
	);

	return null;
});
